type Event = {
    event: string
    value?: string
}
type DataLayer = Event[]

export class Gtm {
    window: Window

    constructor(window: Window) {
        this.window = window
    }

    setEvent = (event: string): void => {
        // @ts-ignore
        const dataLayer: DataLayer = window.dataLayer

        if (!dataLayer) {
            console.warn(
                `Event ${event} not pushed because dataLayer is not present`
            )
            return
        }

        try {
            dataLayer.push({
                event: event
            })
        } catch (e) {
            console.error('Event push ended with error', e)
        }
    }

    paymentSuccess = (email?: string): void => {
        // @ts-ignore
        const dataLayer: DataLayer = window.dataLayer

        if (!dataLayer) {
            console.warn(
                'Event purchase not pushed because dataLayer is not present'
            )
            return
        }

        try {
            dataLayer.push({
                event: 'purchase',
                value: email
            })
        } catch (e) {
            console.error('Event push ended with error', e)
        }
    }
}
